import React from 'react';
import '../css/index.css';

export function DRP() {

    return (

        <div className='wrapper'>

            <h2>For more information, please see <a href="spa-drp.github.io">our website</a>. Feel free to direct any questions, comments or concerns to Daniel Suen (dsuen@uw.edu) and Alex Jiang (jiang14@uw.edu).</h2>

            <p>The DRP is an opportunity for undergraduate students of all backgrounds to work one-on-one with a graduate student in Statistics on an independent reading project throughout Autumn quarter. Applications will be open until September 18, 2022 11:59 PM PDT. To learn more about potential reading projects and to apply, please go to <a href="spa-drp.github.io">spa-drp.github.io</a></p>
            <p> Students will be expected to meet with their mentor once a week and work independently on assigned material for 3-4 hours a week. At the end of the quarter, participants will give a 10 minute presentation and compose a one page writeup about their work. Undergraduate participants may register for 1 credit (CR/NC) of STAT 499. There are no requirements for participation in the Directed Reading Program except for enthusiasm and interest in statistics. We encourage applications from students of all personal backgrounds and identities and levels of experience; you do not need to be a statistics major to apply and we especially encourage applications from those without previous research experience.</p>

        </div>

    )
}